import axios from 'axios';
import Cookies from 'universal-cookie';
import CryptoJS from 'crypto-js';

const regex = /^\/reset\/[\dA-Za-z]*$/;

const cookies = new Cookies();

export function to12Hours(hora24) {
    // Divide la hora en horas y minutos
    const [horas, minutos] = hora24.split(':').map(Number);

    // Verifica si es AM o PM
    const periodo = horas >= 12 ? 'PM' : 'AM';

    // Convierte las horas a formato de 12 horas
    const horas12 = horas % 12 || 12;

    // Crea la hora en formato 12 horas
    const hora12 = `${horas12}:${minutos.toString().padStart(2, '0')} ${periodo}`;

    return hora12;
}

export const showPopup = (getter, setter) => {
    console.log(getter);
    if (getter) {
        document.body.classList.add('overflow-hidden');
    } else {
        document.body.classList.remove('overflow-hidden');
    }

    setter(getter);
};

export function to24Hours(hora12) {
    // Divide la hora en horas, minutos y AM/PM
    const [hora, minutos, periodo] = hora12.match(/(\d+):(\d+)\s*(AM|PM)/i).slice(1);

    // Convierte las horas a número
    let horas24 = parseInt(hora, 10);

    // Ajusta las horas según AM o PM
    if (periodo.toLowerCase() === 'pm' && horas24 !== 12) {
        horas24 += 12;
    } else if (periodo.toLowerCase() === 'am' && horas24 === 12) {
        horas24 = 0;
    }

    // Crea la hora en formato 24 horas
    const hora24 = `${horas24.toString().padStart(2, '0')}:${minutos}`;

    return hora24;
};

export const validarEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
}

export const validateData = (data) => {
    let errors = [];
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    let password = '';
    data.map((item) => {
        if (item.value === '' || item.value === undefined || item.value === null || item.value === 0) {
            errors.push({
                inputName: item.name,
                message: "Campo requerido",
                status: true
            });
            return;
        }

        if (item.name === 'email') {
            if (!validarEmail(item.value)) {
                errors.push({
                    inputName: item.name,
                    message: "Correo electrónico inválido",
                    status: true
                });
            }
            return;
        }

        // Validar que password tenga al menos 8 caracteres, letras, números y caracteres especiales
        if (item.name === 'password') {
            password = item.value;
            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/;

            if (item.value.length < 8 || !regex.test(item.value)) {
                errors.push({
                    inputName: item.name,
                    message: "La contraseña debe tener al menos 8 caracteres, incluyendo mayúsculas, minúsculas, números y caracteres especiales como $@!%*?&",
                    status: true
                });
            }

            return;
        }

        if (item.name === 'password_confirmation') {
            if (item.value !== password) {
                errors.push({
                    inputName: item.name,
                    message: "Las contraseñas no coinciden",
                    status: true
                });
            }
            return;
        }

        if (Array.isArray(item.value)) {
            if (item.value.length === 0) {
                errors.push({
                    inputName: item.name,
                    message: "Debe seleccionar al menos una opción",
                    status: true
                });
            }
            return;
        }

        errors.push({
            inputName: item.name,
            message: "",
            status: false
        });
        return;
    });
    return errors;
}

export const encryptData = (data) => {
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY), {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    const encryptedPassword = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
    return encryptedPassword;
};

export const decryptData = (encryptedData) => {
    const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
    const iv = CryptoJS.lib.WordArray.create(encryptedDataBytes.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedDataBytes.words.slice(4), encryptedDataBytes.sigBytes - 16);
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY), {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};

export const checkSocialMediaLink = (url, type) => {
    try {
        const patterns = {
            facebook: /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9\.\-_]+(\/)?$/,
            instagram: /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9\.\-_]+(\/)?$/,
            twitter: /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/[a-zA-Z0-9_]+(\/)?$/,
            linkedin: /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company|school|pub)\/[a-zA-Z0-9\-_]+\/?$/
        };

        if (!patterns[type]) {
            throw new Error('Red social no permitida');
        }

        if (!patterns[type].test(url)) {
            throw new Error('URL no válida para la red social seleccionada');
        }

        return {
            isValid: true,
            result: url,
            message: 'Red social permitida'
        };
    } catch (error) {
        return {
            isValid: false,
            result: null,
            message: `Inconveniente en la validación de la URL: ${error.message}`
        };
    }
};

export const getOrDeleteRequest = async (action, method, responseType = null, auth = true) => {
    let uri = `${process.env.REACT_APP_API_URI}${action}`;

    let config = {
        method: method,
        url: uri,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };

    if (auth) {
        let token = (cookies.get(process.env.REACT_APP_TOKEN));

        if (!token) {
            token = cookies.get('Bearer');
        }

        config.headers['ApiToken'] = `Bearer ${token.token}`;

        config.url = uri;
    }

    if (responseType !== null) {
        config.responseType = responseType;
    }

    try {
        const response = await axios(config);

        if (Array.isArray(response.data)) {
            return response.data;
        }

        return { ...response.data, type: 'success' };
    } catch (error) {
        console.error(error);

        // Agregando tipo al objeto error
        let errorResponse = { ...error.response.data, type: 'error' };

        return errorResponse;
    }
}

export const postOrPutRequest = async (action, method, data, auth = true, onUploadProgress = null) => {
    let uri = `${process.env.REACT_APP_API_URI}${action}`;

    // 'Content-Type' solo va como multipart/form-data cuando el cuerpo realmente ES un
    // FormData; para objetos planos (incluso en POST) va application/json, si no el backend
    // no logra parsear el body (422) — Reporte Chambaticon/TiconX §2.
    let config = {
        headers: {
            'Content-Type': (data instanceof FormData) ? 'multipart/form-data' : 'application/json',
            'Accept': 'application/json',
        }
    };

    if (auth) {
        let token = cookies.get(process.env.REACT_APP_TOKEN);

        if (!token) {
            token = cookies.get('Bearer');
        }

        config.headers['ApiToken'] = `Bearer ${token.token}`;
    }

    try {
        const response = await axios({
            method: method,
            url: uri,
            data: data,
            headers: config.headers,
            onUploadProgress: onUploadProgress
        });

        return { ...response.data, type: 'success' };
    } catch (error) {
        console.error(error);

        // Agregando tipo al objeto error
        let errorResponse = { ...error.response.data, type: 'error' };

        return errorResponse;
    }
}

export async function getProfileInfo(typeDocument, document, company) {

    const verifyPhoto = {
        typeDocument: encryptData(typeDocument),
        document: encryptData(document),
        client_company_id: company,
    };

    let response = await postOrPutRequest(
        `registro/student-profile-image`,
        'POST',
        verifyPhoto,
        false
    );

    if (response.type === 'success') {
        let imgCompany = "";

        if (!response.data) {
            imgCompany = null;
        } else {
            imgCompany = response.data;
        }
        return imgCompany;
    } else {
        return null;
    }
};

export const formatDate = (dateToFormat) => {
    const dateFormated = new Date(dateToFormat).toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    }).replace('.', '');

    return dateFormated;
}